import type { Table } from 'dexie';
import type { OrderSettingsDropdown } from '@/api/models/OrderSettings';
import db, { Database } from '@/db';

export type TABLE_TYPE = Table<OrderSettingsDropdown, [number, number]>;
export const TABLE = 'notificationEventTypes';

class NotificationEventTypeDatabase {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, '[parentId+id], parentId, sortId');
  }

  async list(notificationTypeId: number): Promise<OrderSettingsDropdown[]> {
    const options = await this.db[TABLE].where('parentId').equals(notificationTypeId).toArray();
    return options.sort((left, right) => left.sortId - right.sortId || left.id - right.id);
  }

  async replace(notificationTypeIds: number[], options: OrderSettingsDropdown[]): Promise<void> {
    await this.db.transaction('rw', this.db[TABLE], async () => {
      await this.db[TABLE].where('parentId').anyOf(notificationTypeIds).delete();
      await this.db[TABLE].bulkPut(options);
    });
  }
}

export const NotificationEventTypeDB = new NotificationEventTypeDatabase(db);
